// fullScreen.js - JS to put scene in full-screen mode
// Copyright (C) 2020 Saxton Technical Event Solutions

document.addEventListener('DOMContentLoaded', (event) => {
  const fullScreenButton = document.getElementById('fullScreenButton');
  if (fullScreenButton) {
    if (/iPhone|iPod/.test(navigator.userAgent)) {
      fullScreenButton.style.visibility = 'hidden';
    } else {
      fullScreenButton.addEventListener('click', () => {
        if ('requestFullscreen' in AFRAME.scenes[0]) {
          AFRAME.scenes[0].requestFullscreen();
        } else if ('webkitRequestFullscreen' in AFRAME.scenes[0]) {
          AFRAME.scenes[0].webkitRequestFullscreen();
        } else {
          console.warn("no requestFullscreen method");
          fullScreenButton.style.visibility = 'hidden';
        }
      });
    }
  } else {
    console.warn("no fullScreenButton");
  }
});
